import { render, staticRenderFns } from "./addAdminStrators.vue?vue&type=template&id=78ba552a&"
import script from "./addAdminStrators.vue?vue&type=script&lang=js&"
export * from "./addAdminStrators.vue?vue&type=script&lang=js&"
import style0 from "./addAdminStrators.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports